import React from "react";

import { WithApolloClient } from "./WithApolloClient";
import { WithLoadingContext } from "./Loading";

type Props = {
  children: React.ReactElement;
  graphqlUri: string;
};

const App: React.FunctionComponent<Props> = ({ children, graphqlUri }) => {
  return (
    <WithLoadingContext>
      <WithApolloClient graphqlUri={graphqlUri}>{children}</WithApolloClient>
    </WithLoadingContext>
  );
};

export default App;
